module.exports = __webpack_public_path__ + "yz/img/快递运输.c75dcd57.png";